export class UsersPermissions {
	see: boolean;
	invite: boolean;
	editRole: boolean;
	destroy: boolean;

	constructor( {
		see = false,
		invite = false,
		editRole = false,
		destroy = false
	} ) {
		this.see = see;
		this.invite = invite;
		this.editRole = editRole;
		this.destroy = destroy;
	}
}

export const ownerUsersPermissions = new UsersPermissions( {
	see: true, invite: true, editRole: true, destroy: true
} );
export const projectManagerUsersPermissions = new UsersPermissions( {
	see: true, invite: true, editRole: true, destroy: true
} );
export const projectEditorUsersPermissions = new UsersPermissions( {
	see: true, invite: true, editRole: true, destroy: true
} );
export const projectReviewerUsersPermissions = new UsersPermissions( {
	see: true, invite: false, editRole: false, destroy: false
} );
export const nullUsersPermissions = new UsersPermissions( {
	see: false, invite: false, editRole: false, destroy: false
} );
